import { render, staticRenderFns } from "./KIcon.vue?vue&type=template&id=419e27ea&scoped=true&"
import script from "./KIcon.vue?vue&type=script&lang=js&"
export * from "./KIcon.vue?vue&type=script&lang=js&"
import style0 from "./KIcon.vue?vue&type=style&index=0&id=419e27ea&prod&lang=scss&scoped=true&"
import style1 from "./KIcon.vue?vue&type=style&index=1&id=419e27ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419e27ea",
  null
  
)

export default component.exports